import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
        >
          <path d="M19.333 0h-6.666A2.67 2.67 0 0010 2.667H6.667A2.67 2.67 0 004 5.333v24A2.67 2.67 0 006.667 32h18.666A2.67 2.67 0 0028 29.333v-24a2.67 2.67 0 00-2.667-2.666H22A2.67 2.67 0 0019.333 0zm-6.666 2.667h6.666v2.666h-6.666l-.001-1.324V4v-.01l-.001-1.323h.002zm12.666 2.666v24H6.667v-24H10A2.67 2.67 0 0012.667 8h6.666A2.67 2.67 0 0022 5.333h3.333z"></path>
          <path d="M19.333 14.667v6.666h-2v-4a1.334 1.334 0 00-2.666 0v4h-2V20A1.334 1.334 0 0010 20v2.667c0 .736.597 1.333 1.333 1.333h9.334c.736 0 1.333-.597 1.333-1.333v-8a1.334 1.334 0 00-2.667 0z"></path>
        </svg>
    );
}